"use client";

import MaxWidthContainer from "./max-width-container";
import CustomLabel from "../ui/custom-label";
import { api } from "@/trpc/react";
import TripSliderLoader from "./trip-slider-loader";
import TripSlider from "./trip-slider";
import { type AdventureType } from "@prisma/client";
import { cn } from "@/lib/utils";

const SimilarPackages = ({
    adventuretype,
    className,
    destinationId,
    slug,
}: {
    destinationId?: string;
    className?: string;
    adventuretype: AdventureType;
    slug: string;
}) => {
    const { data, isLoading } = api.trips.get_trip_by_destination_id.useQuery({ id: destinationId ?? "" });
    if (isLoading) return <TripSliderLoader title={"Similar Packages"} />;

    if (!data || data.length < 1) return null;

    // Filter out the current trip by slug
    const filteredData = data.filter((trip) => trip.slug !== slug);

    if (filteredData.length < 1) return null;

    return (
        <section
            className={cn("relative overflow-hidden pb-8 md:pb-12", className)}
        >
            <MaxWidthContainer className="relative space-y-5">
                <CustomLabel label={"Similar Packages"} />
                <TripSlider
                    navigationBtn={"similar-packages"}
                    data={filteredData}
                    isTrips={adventuretype === "Trip" ? true : false}
                />
            </MaxWidthContainer>
        </section>
    );
};

export default SimilarPackages;
